import { View } from '@react-pdf/renderer';

import { styles } from './styles';

type HeaderProps = {
  children: React.ReactNode;
};

export function Header({ children }: HeaderProps) {
  return <View style={styles.row}>{children}</View>;
}
